window.Template = function () {
    var el = this;
    var autosaveId = 0;
    el.current = {};
    el.groups = {};
    el.items = {};

    el.show = function () {
        var templateData = {
            groups: []
        };

        var format = el.format.current;
        var i, companyId, item, groups = {}, keys;
        for (companyId in el.items) {
            for (i in el.items[companyId]) {
                item = $.extend(true, {}, el.items[companyId][i]);

                if (format.id !== item.format_id) {
                    continue;
                }

                if (!groups.hasOwnProperty(item.group_id)) {
                    groups[item.group_id] = {
                        name: el.groups[item.group_id].name,
                        items: [],
                        id: item.group_id,
                    };
                }

                keys = Object.keys(item.data.workareas);
                item.workarea_id = keys.length > 1 ? keys[1] : keys[0];
                item.company_id = companyId;
                groups[item.group_id].items.push(item);
            }
        }

        for (i in groups) {
            templateData.groups.push(groups[i]);
        }
        
        if(templateData.hasOwnProperty('groups') && templateData.groups.length > 0 ){
            templateData.groups[0].is_active = true;
        }

        el.dialog.show('templates', templateData);
    };
    
    el.set = function(companyId, id) {
        el.upImages.reset();
        el.workarea.init($.extend(true, {}, el.items[companyId][id].data));
        el._parent.project.current.template_id = id;
        el.calendarGrid.updateDate();
        el.workarea.render();
        el.preview.render();
        el.dialog.hide('templates');
    };
    
    el.get = function(id) {
        var companyId, templateId;
        for (companyId in el.items) {
            for (templateId in el.items[companyId]) {
                if (parseInt(templateId) === parseInt(id)) {
                    return $.extend(true, {}, el.items[companyId][templateId]);
                }
            }
        }
        
        return false;
    };
    
    el.getFirst = function () {
        var templateId, companyId, template;
        for (companyId in el.items) {
            for (templateId in el.items[companyId]) {
                template = el.items[companyId][templateId];
                
                if (template.format_id === el.format.current.id) {
                    return $.extend(true, {}, template);
                }
            }
        }
        
        return false;
    };
    
    el.getWorkarea = function(template, index) {
        var number = 0;
        var i;
        for (i in template.workareas) {
            if (number === index) {
                return template.workareas[i];
            }

            number++;
        }
        
        return false;
    };

    el.load = function (template) {
        el._parent.isCheckingOnloadStatus = true;
        el._parent.workData = {};
        el.current = template;

        el.format.current = el.format.items[template.format_id];

        if (Object.keys(template.data).length > 0) {
            el._parent.workData = template.data;
            // generateWorkdataId();
            el._parent.selectWorkareaId = Object.keys(el.workData.workareas)[0];
        } else {
            el.workarea.initTemplate();
        }

        if (el.current.data.hasOwnProperty('language') && el.current.data.language !== undefined) {
            el.language.set(el.current.data.language);
        }
        
        el.calendarGrid.init();
        el.upImages.init();
        el.preview.render();
        el.workarea.render();
        el.startAutoSave();
        el.history.init();
    };
    
    //  generate workdata id if not specified (it is not known why some templates ids are not generated )
    function generateWorkdataId() {
        var existZeroId = false;
        var id = 1;
        for (i in el._parent.workData.workareas) {
            var workarea = el._parent.workData.workareas[i];
            if (workarea.id === 0 && existZeroId === false) {
                existZeroId = true;
                el._parent.workData.workareas[i].id = id;
            }
            if (workarea.id === 0  && existZeroId) {
                el._parent.workData.workareas[i].id = id;
                el._parent.workData.workareas[i].name = id
                id++;
            }
        }
    }

    el.save = function (cb) {
        el.loader.show(Yii.t('Saving a project...'));
        var data = {
            data: JSON.stringify(el.workData)
        };

        el.request.post(window.requestUrls.saveTemplate + window.bookSid, data, function (response) {
            el.loader.hide();
            if (response.hasOwnProperty('error')) {
                alert(response.error);
                el.loader.hide();
                return false;
            } else {
                if (cb !== undefined) {
                    cb();
                }
            }
        }, 'json', false);
    };

    el.startAutoSave = function () {
        autosaveId = setInterval(function () {
            var data = {
                data: JSON.stringify(el.workData)
            };

            el.request.post(window.requestUrls.saveTemplate + window.bookSid, data, function (response) {
                if (response.hasOwnProperty('error')) {
                    alert(response.error);
                    clearTimeout(autosaveId);
                }
            }, 'json');
        }, 30000);
    };

    $('.js-templates-show').on('click', function () {
        el.show();
    });
    
    $(document).on('click', '.js-template-set', function() {
        var element = $(this);
        el.set(element.attr('data-company'), element.attr('data-id'));
    });
};